import { FloatingPortal } from "@floating-ui/react"

import { classNames } from "../../../../../lib/classNames"
import { TABLE_CELL_BASE_STYLES } from "../../TableCell/TableCell"
import { TABLE_HEADER_CELL_STYLES } from "../../TableHeaderCell/TableHeaderCell"

export interface DragGhostProps {
  title: string
  size: { width: number; height: number }
  position: { x: number; y: number }
}

export function DragGhost({ title, size, position }: DragGhostProps) {
  const { x, y } = position
  const { width, height } = size

  const style = {
    left: x - width / 2,
    top: y - height / 2,
    width,
    height,
  }

  return (
    <FloatingPortal>
      <div
        style={style}
        className={classNames(
          ...TABLE_CELL_BASE_STYLES,
          TABLE_HEADER_CELL_STYLES,
          "animate-enter z-11 shadow-surface fixed flex cursor-grabbing items-center rounded border"
        )}
      >
        {title}
      </div>
    </FloatingPortal>
  )
}
